export const FALLBACK_HANDLING_UNIT = 'Pcs';
